
/**
 * CreateOcorrenciaInspecaoPatrimonioUseCase
 */

import { ICreateOcorrenciaInspecaoPatrimonioUseCase } from "../../../presentation/useCases/create/create_ocorrencia_inspecao_patrimonio_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

export class CreateOcorrenciaInspecaoPatrimonioUseCase implements ICreateOcorrenciaInspecaoPatrimonioUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async createOcorrenciaInspecaoPatrimonio(
    idInspecaoPatrimonio?: number,
    idInspecaoPatrimonioItens?: number,
    dataCriacao?: Date,
    descricao?: string,
    inspecao?: number,
    arquivo1?: File,
    arquivo2?: File,
    descricaoArquivo1?: string,
    descricaoArquivo2?: string,
  ): Promise<number> {
    const computedNomeArquivo = arquivo1 ? arquivo1.name : undefined;
    const computedArquivo = arquivo1 ? arquivo1 : undefined;

    const computedNomeArquivo2 = arquivo2 ? arquivo2.name : undefined;
    const computedArquivo2 = arquivo2 ? arquivo2 : undefined;
    return this.repository.createOcorrenciaInspecaoPatrimonio(
      idInspecaoPatrimonio,
      idInspecaoPatrimonioItens,
      dataCriacao,
      descricao,
      inspecao,
      computedArquivo,
      computedArquivo2,
      computedNomeArquivo,
      computedNomeArquivo2,
      descricaoArquivo1,
      descricaoArquivo2,
    );
  }
}
